export default (item) =>
  item.total_stock === undefined ?
    item.sizes.filter(size_obj => size_obj.total_stock > 0).length > 0 :
    item.total_stock > 0
